
import { Vue, Component, Prop } from 'vue-property-decorator';

/**
 * 开屏 GIF（用 GIF 代替视频，兼容性更好）
 * - 加载完成后按 GIF 总时长计时，播完停留 300ms，再淡出进入首页
 * - GIF 加载失败 / 长时间未加载完，也会进入首页，不卡住用户
 */
@Component
export default class SplashGif extends Vue {
  @Prop({ type: String, default: '' }) readonly src!: string;

  leaving = false;

  private finished = false;
  private timer: number | null = null;
  // GIF 总时长（ms）：47 帧，帧延迟合计 4.77s
  private readonly gifDuration = 4800;
  // 播放结束后停留时长（ms）
  private readonly endHold = 300;
  // 淡出时长（ms）
  private readonly leaveDuration = 300;
  // 加载超时兜底（ms）
  private readonly loadTimeout = 10000;

  mounted() {
    // 兜底：GIF 一直没加载完也不能卡住
    this.timer = window.setTimeout(() => this.enter(), this.loadTimeout);
  }

  beforeDestroy() {
    this.clearTimer();
  }

  // GIF 加载完成后开始按总时长计时
  onLoaded() {
    this.clearTimer();
    this.timer = window.setTimeout(() => this.enter(), this.gifDuration);
  }

  enter() {
    if (this.finished) return;
    this.finished = true;
    this.clearTimer();
    // 播放结束后先停留 300ms，再淡出进入首页
    window.setTimeout(() => {
      this.leaving = true;
      window.setTimeout(() => this.$emit('ended'), this.leaveDuration);
    }, this.endHold);
  }

  private clearTimer() {
    if (this.timer) {
      window.clearTimeout(this.timer);
      this.timer = null;
    }
  }
}
